import { useEffect, useState } from "react";
import { GetLogDumpListReqQuery } from "../types/logDumpContract";
import { LogDump } from "../types/logDump";
import apiGetLogDumpList from "../api/logDump/apiGetLogDumpList";
import { useAppContext } from "../contexts/DataContext";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";

const useLogDumpList = (query?: GetLogDumpListReqQuery) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const {dispatch}= useAppContext()
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<LogDump[]>([]);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async (newQuery?: GetLogDumpListReqQuery) => {
    if (newQuery) query = newQuery;

    let resData: LogDump[] | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetLogDumpList(query);

      setData(res.json.data);
      dispatch({
        type: 'GET',
        payload: {
          type: 'logDumps',
          data: res.json.data
        }
      });
      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
  };
};

export default useLogDumpList;
